import React from "react";
import { Skeleton, Box, Card, CardContent } from "@mui/material";
import { useTheme } from "../../theme/ThemeContext";

export const ProductCardSkeleton = () => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        height: "100%",
        backgroundColor: theme?.homepage_product_card_background,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      {/* Image skeleton */}
      <Skeleton
        variant="rectangular"
        width="100%"
        height={220}
        sx={{
          backgroundColor: theme?.store_background_color,
        }}
      />

      {/* Content skeleton */}
      <CardContent
        sx={{
          backgroundColor: theme?.homepage_product_name_background,
          padding: "16px",
          textAlign: "center",
        }}
      >
        {/* Product name skeleton */}
        <Skeleton
          variant="text"
          width="80%"
          height={24}
          sx={{
            backgroundColor: theme?.store_background_color,
            margin: "0 auto 8px",
          }}
        />

        {/* Price skeleton */}
        <Skeleton
          variant="text"
          width="60%"
          height={20}
          sx={{
            backgroundColor: theme?.store_background_color,
            margin: "0 auto",
          }}
        />
      </CardContent>
    </Card>
  );
};

export const ProductDetailsSkeleton = () => {
  const theme = useTheme();
  return (
    <Box sx={{ padding: 3 }}>
      <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 4 }}>
        {/* Image skeleton */}
        <Box sx={{ flex: 1 }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={400}
            sx={{
              backgroundColor: theme?.store_background_color,
              borderRadius: 2,
            }}
          />
        </Box>

        {/* Content skeleton */}
        <Box sx={{ flex: 1 }}>
          <Skeleton
            variant="text"
            width="90%"
            height={40}
            sx={{
              ...theme?.skeleton_background,
              marginBottom: 2,
            }}
          />
          <Skeleton
            variant="text"
            width="60%"
            height={32}
            sx={{
              ...theme?.skeleton_background,
              marginBottom: 3,
            }}
          />
          <Skeleton
            variant="text"
            width="100%"
            height={20}
            sx={{
              ...theme?.skeleton_background,
              marginBottom: 1,
            }}
          />
          <Skeleton
            variant="text"
            width="100%"
            height={20}
            sx={{
              ...theme?.skeleton_background,
              marginBottom: 1,
            }}
          />
          <Skeleton
            variant="text"
            width="80%"
            height={20}
            sx={{
              ...theme?.skeleton_background,
              marginBottom: 3,
            }}
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={48}
            sx={{
              ...theme?.skeleton_background,
              borderRadius: 2,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
